var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2.5v1H2.719A2 2 0 0 0 .741 6.7l-.707 4.678a3.041 3.041 0 0 0-.034.447V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.175a3.117 3.117 0 0 0-.034-.45l-.71-4.675A2 2 0 0 0 13.281 5H6.5V4H9a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm1 1.5h5a.5.5 0 0 1 0 1H3a.5.5 0 0 1 0-1zm-1 12a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm1.5-6.75a.75.75 0 1 1-.75.75.748.748 0 0 1 .75-.75zm2.25.75a.75.75 0 1 1 .75.75.748.748 0 0 1-.75-.75zM5 9.25a.75.75 0 1 1-.75.75.748.748 0 0 1 .75-.75zM8.75 7.5a.75.75 0 1 1 .75.75.748.748 0 0 1-.75-.75zM8 9.25a.75.75 0 1 1-.75.75.748.748 0 0 1 .75-.75zm3.75-1.75a.75.75 0 1 1 .75.75.748.748 0 0 1-.75-.75zM11 9.25a.75.75 0 1 1-.75.75.748.748 0 0 1 .75-.75z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCash);
export default __webpack_public_path__ + "static/media/icon-cash.f101e121fdcc90efd0d1cda618a605ce.svg";
export { ForwardRef as ReactComponent };